import { Pass, ATP, DrugDetailsEachOtherBottleSize } from './../../models/drug-details';
import { RpoToolService } from './../../services/rpo-tool.service';
import { RecommendedCanisterList, CanisterSubInfo, AssignCanister } from './../../models/canister';
import { ChangeDetectorRef, Component, ElementRef, Inject, OnInit, Optional, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastService } from 'src/app/shared/services/toast.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import * as constants from 'src/app/config/app-constants';
import { ImportWizardInventoryComponent } from '../import-wizard-inventory/import-wizard-inventory.component';
import { MatLegacyTable as MatTable, MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { MatSort } from '@angular/material/sort';
import { DeviceData, DrugCharacteristics, Image } from '../../models/drug-details';
import { ImportWizardImageSlideComponent } from '../import-wizard-image-slide/import-wizard-image-slide.component';
import { HttpErrorResponse } from '@angular/common/http';
import { GetInventory } from '../../models/inventory';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { RecommendationDrug, UpdateDrug, UpdateDcr } from '../../models/drug';
import { DropDown, DropDownDosageForm, DropDownTwo } from '../../models/dropdown';
import { debounceTime, distinctUntilChanged, filter, map, Observable, startWith, tap } from 'rxjs';
import { DropdownValues } from '../../models/synmed-data';
import { ErrorHandlerService } from '../../services/error-handler.service';
import { ImportWizardAlertComponent } from '../import-wizard-alert/import-wizard-alert.component';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { AlertWizardComponent } from 'src/app/internal-user/im-tool/components/alert-wizard/alert-wizard.component';
import { ImportWizardPillIdDetailsComponent } from '../import-wizard-pill-id-details/import-wizard-pill-id-details.component';
import { OtherBottleSizeWizardComponent } from '../other-bottle-size-wizard/other-bottle-size-wizard.component';

@Component({
  selector: 'app-import-wizard-drug-details',
  templateUrl: './import-wizard-drug-details.component.html',
  styleUrls: ['./import-wizard-drug-details.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class ImportWizardDrugDetailsComponent implements OnInit {
  listOfClassificationShape: DropDown[] = [];
  isSynmedCalculating: boolean = false;
  isMaxCalculating: boolean = false;
  isTcgCalculating: boolean = false;
  listOfATPDrugStatus: DropDown[] = [];
  listOfMAXDrugStatus: DropDown[] = [];
  listOfSynmedDrugStatus: DropDown[] = [];
  listOfSmallDropHeight: DropDown[] = [];
  listOfPASSDrugStatus: DropDown[] = [];
  listOfPillType: DropDown[] = [];
  listOfColor: DropDown[] = [];
  listOfCoating: DropDownTwo[] = [];
  listOfScoaring: DropDown[] = [];
  listOfDistributor: DropDown[] = [] as DropDown[]
  listOfDosageForm: DropDownDosageForm[] = [] as DropDownDosageForm[]
  listOfRoa: DropDown[] = [] as DropDown[]
  listOfManufacturer: DropDown[] = [] as DropDown[]
  listOfDrugName: DropDown[] = [] as DropDown[]
  listOfGenericName: DropDown[] = [] as DropDown[]
  listOfPackageType: DropDown[] = [] as DropDown[];
  listOfOTC: DropDown[] = [];
  listOfDnuReason: DropDown[] = [] as DropDown[];
  quarantineReasonList: DropDown[] = [] as DropDown[];
  shapeList: DropDown[] = [] as DropDown[];

  listOfDrugStatus: DropDown[] = [];

  validHeights = [1.00, 1.25, 1.50, 1.75, 2.00, 2.25, 2.50, 2.75, 3.00, 3.25, 3.50, 3.75, 4.00, 4.25, 4.50, 4.75];
  validWidths = ['A.00', 'A.25', 'A.50', 'A.75', 'B.00', 'B.25', 'B.50', 'B.75',
    'C.00', 'C.25', 'C.50', 'C.75', 'D.00', 'D.25', 'D.50', 'D.75',
    'E.00', 'E.25', 'E.50', 'E.75'];
  validPressures = [15, 20, 25, 30, 35, 40, 45, 50, 55, 60];
  validBaffles = [1, 2, 3, 4];

  preferredPipetteSize = DropdownValues.PreferredPipetteSize;
  preferredContainerSize = DropdownValues.PreferredContainerSize;
  smallPipetteDropHeight = DropdownValues.SmallPipetteDropHeight;
  largePipetteDropHeight = DropdownValues.LargePipetteDropHeight;
  preferredLidHoleSize = DropdownValues.PreferredLidHoleSize;
  lidHoleSize = DropdownValues.LidHoleSize;
  massIndex = DropdownValues.MassIndex;
  toggleOptions = DropdownValues.CommonBooleanDropDownValues;
  synmedLabOptimizeds = DropdownValues.CommonBooleanDropDownValues;
  fragileFlags = DropdownValues.CommonBooleanDropDownValues;


  countryList: DropDown[] = [];
  listOfDrugClassificationType: DropDown[] = [];
  scheduleList: DropDownTwo[] = [];
  unitList: DropDown[] = [];
  listOfNiosh: DropDown[] = [];

  ndc: string;
  dataSourceId: number;
  caseNo: string;
  drugCharacteristicsModel: DrugCharacteristics = {} as DrugCharacteristics
  otherBottleSizes: DrugDetailsEachOtherBottleSize[] = [];
  inventoryList: GetInventory[] = [];
  images: Image = {};
  devicesModel: DeviceData[] = [];
  passModel: Pass = {} as Pass;
  atpModel: ATP = {} as ATP;
  defaultImage: string = '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'
  dataSourceDevice = new MatTableDataSource<DeviceData>();
  listOfRecommendationDrug: RecommendationDrug[] = [];
  inventoryId: number = 0;
  dataSourceRecommendationDrug = new MatTableDataSource<RecommendedCanisterList>();
  expandedElement: RecommendedCanisterList | null;
  canisterData: RecommendedCanisterList[] = [];
  usersData: RecommendedCanisterList[] = [];
  assignCanisterModel: AssignCanister;
  drugUpdateModel: UpdateDrug;
  dcrUpdateModel: UpdateDcr;
  @ViewChild('outerSort', { static: true }) sort: MatSort;
  @ViewChildren('innerSort') innerSort: QueryList<MatSort>;
  @ViewChildren('innerTables') innerTables: QueryList<MatTable<CanisterSubInfo>>;
  columnsToDisplay = ['isChecked', 'canisterRecipe', 'matchLevel', 'medName', 'dItem'];
  innerDisplayedColumns = ['pillType', 'length', 'width', 'thickness', 'pieceWeight', 'diagonal'];
  displayedDetailsColumns: string[] = ['partType', 'part', 'partNo']; // Column definitions

  dataSource = [];
  isRecommendedShow: boolean = false;
  isCanisterDetails: boolean = false;
  isSnapCanisterDetails: boolean = false;
  isLoading: boolean = false;
  drugName?: string;
  saveModelForm: FormGroup;
  isDcrClosed: boolean = false;
  // Colors
  @ViewChild('colorInput') colorInput: ElementRef<HTMLInputElement>;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  selectedColors: string[] = [];
  allColors: string[] = [];
  filteredColors: Observable<string[]>;

  //#region  Extra parameters
  source: number;
  schemaName: string;
  drugId: number;
  canisterId?: string;
  snapCanisterId?: string;
  isDisableEditForSource: boolean = false;
  //#endregion

  genericName = new FormControl('')
  colorId = new FormControl('', Validators.required);
  color = new FormControl('', Validators.required);
  scoringId = new FormControl('', Validators.required);
  packageTypeId = new FormControl('');
  distributorId = new FormControl('');
  routeOfAdminId = new FormControl('');
  dosageFormId = new FormControl('');
  isSuperCellOnly = new FormControl('');
  manufacturerId = new FormControl('');
  drugNameId = new FormControl('');
  drugStatusId = new FormControl('');
  otcId = new FormControl('');
  niosh = new FormControl('');


  openOtherBottleSizesImportWizard() {
    const dialogRef = this.dialog.open(OtherBottleSizeWizardComponent, {
      backdropClass: ['smDialog'],
      disableClose: true,
      data: {
        otherBottleSizes: this.otherBottleSizes,
        title: 'Other Bottle Sizes',
        cancelBtnText: "Cancel",
        confirmBtnText: "Ok",
        confirmButtonColor: "btn-light-blue",
        cancelButtonColor: "btn-light-red",
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log("result", result);
    });
  }



  // Custom validator to ensure at most 2 colors are selected
  maxTwoColorsValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const selectedColors = (control.value as string || '').split(',').filter(color => color.trim() !== '');
      return selectedColors.length > 2 ? { maxColors: true } : null;
    };
  }

  requiredColorValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const selectedColors = (control.value as string || '').split(',').filter(color => color.trim() !== '');
      return selectedColors.length === 0 ? { colorRequired: true } : null;
    };
  }
  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (value && this.allColors.includes(value) && !this.selectedColors.includes(value)) {
      if (this.selectedColors.length < 2) {
        this.selectedColors.push(value);
      } else {
        this.toastService.openToast(
          'You can select a maximum of 2 colors only',
          constants.ToastPanelType.error,
          2
        );
      }
    }

    event.chipInput!.clear();
    this.colorId.setValue(this.selectedColors.join(','));
    console.log(this.colorId);
    this.colorId.updateValueAndValidity();
  }

  remove(color: string): void {
    const index = this.selectedColors.indexOf(color);
    if (index >= 0) {
      this.selectedColors.splice(index, 1);
    }
    this.colorId.setValue(this.selectedColors.join(','));
    this.colorId.updateValueAndValidity();
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    const value = event.option.viewValue;
    // Ensure value is not empty or invalid before adding to the selectedColors
    if (value && value.trim() !== '' && !this.selectedColors.includes(value)) {
      if (this.selectedColors.length < 2) {
        this.selectedColors.push(value);
      }
    }
    this.colorInput.nativeElement.value = ''; // Reset the input field
    this.colorId.setValue(this.selectedColors.join(',')); // Update the form control
    this.colorId.updateValueAndValidity(); // Re-validate the form control
  }


  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.allColors.filter(color => color.toLowerCase().includes(filterValue));
  }

  constructor(
    public dialogRef: MatDialogRef<ImportWizardDrugDetailsComponent>,
    public dialog: MatDialog,
    private rpoToolService: RpoToolService,
    private ngxLoader: NgxUiLoaderService,
    private errorHandlerService: ErrorHandlerService,
    private toastService: ToastService,
    private cd: ChangeDetectorRef,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    this.ndc = data.ndc;
    this.dataSourceId = data.dataSourceId;
    this.caseNo = data.caseNo;
  }

  ngOnInit(): void {
    this.getQuarantineReasonList();
    this.getClassificationShape();
    this.getAtpDrugStatus();
    this.getPassDrugStatus();
    this.getMaxDrugStatus();
    this.getPillType();
    this.getCoating();
    this.getScoring();
    this.getOtc();
    this.getCountryList();
    this.getDrugClassificationType();
    this.getSynmedDrugStatus();
    this.getDrugNonCountReasonList();
    this.getScheduleList();
    this.getUnitList();
    this.getShapeList();
    this.getCommonDrugStatus();
    this.getNiosh();
    setTimeout(() => {
      this.getDrugByndc();
    }, 1000)
    this.saveModelForm = new FormGroup({
      classificationShapeId: new FormControl(''),
      length: new FormControl(''),
      width: new FormControl(''),
      thickness: new FormControl(''),
      pieceWeight: new FormControl(''),
      diagonal: new FormControl(),
      ndc: new FormControl(''),
      dnumber: new FormControl(''),
      packageBarcode: new FormControl(''),
      packageBarcode2d: new FormControl(''),
      packageThirtyDramCapacity: new FormControl(''),
      coatingId: new FormControl('', Validators.required),
      quarantineId: new FormControl(''),
      shapeId: new FormControl(''),
      packageImprint1: new FormControl(''),
      packageImprint2: new FormControl(''),
      colorId: this.colorId,
      // color: this.color,
      scoringId: new FormControl('', Validators.required),
      maxThirtyDramDnu: new FormControl(''),
      maxDoNotUse: new FormControl(''),
      maxDrugStatus: new FormControl(''),
      maxCellHeight: new FormControl(''),
      maxCellWidth: new FormControl(''),
      maxBaffle: new FormControl(''),
      maxPressure: new FormControl(''),
      maxLabOptimized: new FormControl(null),
      atpDrugStatus: new FormControl(''),
      atpTcgDiameter: new FormControl(''),
      atpTcgPillType: new FormControl(''),
      atpTcgPillVolume: new FormControl(''),
      atpTcgT1: new FormControl(''),
      atpTcgT2: new FormControl(''),
      atpTcgWidth: new FormControl(),
      atpTcgLength: new FormControl(),
      atpCanisterNumber: new FormControl(''),
      atpLabOptimized: new FormControl(null),
      passDrugStatus: new FormControl(''),
      passLabOptimized: new FormControl(null),
      synmedLabOptimized: new FormControl(null),
      recommendationType: new FormControl('1'),
      massIndex: new FormControl(''),
      lidHole: new FormControl(''),
      lidVolcanic: new FormControl(''),
      fragileFlag: new FormControl(''),
      toggle: new FormControl(''),
      synmedDrugStatus: new FormControl(''),
      containerSize: new FormControl(''),
      pipetteSize: new FormControl(''),
      distributorId: this.distributorId,
      routeOfAdminId: this.routeOfAdminId,
      dosageFormId: this.dosageFormId,
      manufacturerId: this.manufacturerId,
      drugNameId: this.drugNameId,
      drugStatusId: this.drugStatusId,
      otcId: this.otcId,
      packageSize: new FormControl('', Validators.required),
      packageDepth: new FormControl(0),
      packageHeight: new FormControl(0),
      packageTypeId: this.packageTypeId,
      packageWidth: new FormControl(0),
      drugClassificationType: new FormControl(''),
      country: new FormControl(''),
      oralSolid: new FormControl(true),
      cellCapacity: new FormControl(),
      superCellCapacity: new FormControl(),
      canisterCapacity: new FormControl(),
      highCapCapacity: new FormControl(),

      nonCountReasonId: new FormControl(),
      largePipetteDropHeight: new FormControl(),
      smallPipetteDropHeight: new FormControl(),
      preferredLidHoleSize: new FormControl(),
      preferredContainerSize: new FormControl(),
      preferredPipetteSize: new FormControl(),
      smallCanisterCapacity: new FormControl(),
      largeCanisterCapacity: new FormControl(),

      genericName: this.genericName,
      strength: new FormControl('', this.positiveRealNumberValidator()),
      unitId: new FormControl(),
      drugId: new FormControl(''),
      active: new FormControl(''),
      scheduleId: new FormControl(),
      manufacturer: new FormControl(''),
      otc: new FormControl(''),
      dosageForm: new FormControl(''),
      niosh: new FormControl(''),
      antibiotics: new FormControl(''),
      unitOfUse: new FormControl(''),
      unitDose: new FormControl(''),
      updated: new FormControl(''),
      storageConditions: new FormControl(''),
      gpi: new FormControl(''),
      gcn: new FormControl(''),
      shape: new FormControl(''),
      drugName: new FormControl(''),
      isSuperCellOnly: this.isSuperCellOnly
    });

    console.log("Form initialized:", this.saveModelForm);

    this.setupFormWatchers();

    console.log("Form watchers set up.");

    this.filteredColors = this.colorId.valueChanges.pipe(
      debounceTime(300), // Delay processing to allow user input stabilization
      distinctUntilChanged(), // Ignore duplicate values
      tap(value => {
        // Handle API call in a centralized manner
        if (value && !Number.isFinite(value)) {
          this.isLoading = true;
          setTimeout(() => {
            this.getColor(value); // Call API only for valid inputs
            this.isLoading = false;
          }, 400);
        }
      }),
      map((color: string | null) => (color ? this._filter(color) : this.allColors.slice())) // Filter colors for dropdown
    );

    // Handle initial value explicitly
    if (this.colorId.value && !Number.isFinite(this.colorId.value)) {
      this.getColor(this.colorId.value);
    }



    this.distributorId.valueChanges
      .pipe(
        debounceTime(300), // Wait 300ms for user input stabilization
        distinctUntilChanged(), // Ignore duplicate values
        filter(value => value && !Number.isFinite(value)) // Process only valid non-numeric values
      )
      .subscribe(searchTerm => {
        this.isLoading = true;
        setTimeout(() => {
          this.getDistributor(searchTerm); // Make the API call
          this.isLoading = false;
        }, 400);
      });

    // Handle the initial value explicitly
    if (this.distributorId.value && !Number.isFinite(this.distributorId.value)) {
      this.getDistributor(this.distributorId.value);
    }




    this.routeOfAdminId.valueChanges
      .pipe(
        debounceTime(300), // Delay processing to wait for user input to stabilize
        distinctUntilChanged(), // Ignore duplicate values
        filter(value => value && !Number.isFinite(value)) // Process only non-null, non-numeric values
      )
      .subscribe(searchTerm => {
        this.isLoading = true;
        setTimeout(() => {
          this.getRoa(searchTerm); // API call
          this.isLoading = false;
        }, 400);
      });

    // Handle initial value explicitly
    if (this.routeOfAdminId.value && !Number.isFinite(this.routeOfAdminId.value)) {
      this.getRoa(this.routeOfAdminId.value);
    }




    this.manufacturerId.valueChanges
      .pipe(
        debounceTime(300), // Delay for 300ms after the last input
        distinctUntilChanged(), // Prevent duplicate emissions
        filter(value => value && !Number.isFinite(value)) // Skip null, undefined, or numeric values
      )
      .subscribe(searchTerm => {
        this.isLoading = true;
        setTimeout(() => {
          this.getManufacture(searchTerm); // Call the API only for valid values
          this.isLoading = false;
        }, 400);
      });

    // Handle the initial value explicitly
    if (this.manufacturerId.value && !Number.isFinite(this.manufacturerId.value)) {
      this.getManufacture(this.manufacturerId.value);
    }

    this.drugNameId.valueChanges
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        filter(value => value && !Number.isFinite(value))
      )
      .subscribe(searchTerm => {
        setTimeout(() => {
          if (searchTerm && searchTerm.length > 2) {
            this.isLoading = true;
            this.getDrugName(searchTerm);
          }
          else {
            this.listOfDrugName = [];
          }
          this.isLoading = false;
        }, 400);
      });

    if (this.drugNameId.value && !Number.isFinite(this.drugNameId.value)) {
      this.getDrugName(this.drugNameId.value);
    }


    this.genericName.valueChanges
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        filter(value => value && !Number.isFinite(value))
      )
      .subscribe(searchTerm => {
        setTimeout(() => {
          if (searchTerm && searchTerm.length > 2) {
            this.isLoading = true;
            this.getGenericName(searchTerm);
          }
          else {
            this.listOfGenericName = [];
          }
          this.isLoading = false;
        }, 400);
      });

    if (this.genericName.value && !Number.isFinite(this.genericName.value)) {
      this.getGenericName(this.genericName.value);
    }



    this.dosageFormId.valueChanges
      .pipe(
        debounceTime(300), // Wait 300ms after the last input
        distinctUntilChanged(), // Ignore duplicate values
        filter(value => value && !Number.isFinite(value)) // Skip null, undefined, or numeric values
      )
      .subscribe(searchTerm => {
        this.isLoading = true;
        setTimeout(() => {
          this.getDosageForm(searchTerm); // Call the API
          this.isLoading = false;
        }, 400);
      });

    // Handle the initial value explicitly
    if (this.dosageFormId.value && !Number.isFinite(this.dosageFormId.value)) {
      this.getDosageForm(this.dosageFormId.value);
    }



    this.packageTypeId.valueChanges
      .pipe(
        debounceTime(300),
        distinctUntilChanged(), // Ensures API is not called for duplicate values
        filter(value => value && !Number.isFinite(value)) // Skip invalid or empty values
      )
      .subscribe(searchTerm => {
        this.isLoading = true;
        setTimeout(() => {
          this.getPackageType(searchTerm); // Call the API
          this.isLoading = false;
        }, 400);
      });

  }


  displayFnColor(value?: any) {
    if (this.listOfColor.length == 0) {
      return undefined
    }
    else {
      return value ? this.listOfColor.find(_ => _.value === value).label : undefined;
    }
  }

  displayFnDistributor(value?: any) {
    if (this.listOfDistributor.length == 0) {
      return undefined
    }
    else {
      let data = value ? this.listOfDistributor.find(_ => _.value === value).label : undefined;
      this.listOfDistributor = [] as DropDown[];
      return data;
    }
  }
  displayFnDosageForm(value?: any) {
    if (this.listOfDosageForm.length == 0) {
      return undefined
    }
    else {
      let data = value ? this.listOfDosageForm.find(_ => _.id === value).description : undefined;
      this.listOfDosageForm = [] as DropDownDosageForm[];
      return data;
    }
  }

  displayFnRoa(value?: any) {
    if (this.listOfRoa.length == 0) {
      return undefined
    }
    else {
      let data = value ? this.listOfRoa.find(_ => _.value === value).label : undefined;
      this.listOfRoa = [] as DropDown[];
      return data;
    }
  }

  displayFnManufacturer(value?: any) {
    if (this.listOfManufacturer.length == 0) {
      return undefined
    }
    else {
      let data = value ? this.listOfManufacturer.find(_ => _.value === value).label : undefined;
      this.listOfManufacturer = [] as DropDown[];
      return data;
    }
  }

  displayFnDrugName(value?: any) {
    return value;
  }

  displayFnGenericName(value?: any) {
    return value;
  }

  displayFnPacakgeType(value?: any) {
    if (this.listOfPackageType.length == 0) {
      return undefined
    }
    else {
      return value ? this.listOfPackageType.find(_ => _.value === value).label : undefined;
    }
  }


  displayFnDrugStatus(value?: any) {
    if (this.listOfDrugStatus.length == 0) {
      return undefined
    }
    else {
      return value ? this.listOfDrugStatus.find(_ => _.value === value).label : undefined;
    }
  }

  displayedColumns: string[] = ['deviceName', 'drugStatus', 'deviceStatus', 'labOptimizedStatus']

  canisterChecked(row: any, isChecked: boolean) {

    this.assignCanisterModel = {
      ndc: this.drugCharacteristicsModel.drugId,
      canisterRecipe: this.saveModelForm.value.recommendationType == 1 ? row.canisterRecipe : null,
      snapRecipe: this.saveModelForm.value.recommendationType == 2 ? row.snapRecipe : null
    }

  }
  inventorySelect(inventoryId: number, isChecked: boolean) {
    this.inventoryId = inventoryId;
  }

  toggleRow(element: RecommendedCanisterList) {
    element.canisters && (element.canisters as MatTableDataSource<CanisterSubInfo>).data.length ? (this.expandedElement = this.expandedElement === element ? null : element) : null;
    this.cd.detectChanges();
    this.innerTables.forEach((table, index) => (table.dataSource as MatTableDataSource<CanisterSubInfo>).sort = this.innerSort.toArray()[index]);
  }
  openDrugDetailsImportWizard() {
    const dialogRef = this.dialog.open(ImportWizardDrugDetailsComponent, {
      backdropClass: ['lgDialog'],
      disableClose: true,
    });

  }
  forbiddenNamesValidator(Services: any[]): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {

      if (!control.value) {
        return null;
      }
      const index = Services.findIndex(Service => {
        const escapedId = this.escapeRegExp(Service.value.toString());
        return new RegExp(`^${escapedId}$`).test(control.value);
      });
      return index < 0 ? { forbiddenNames: { value: control.value } } : null;
    };
  }

  forbiddenColorValidator(Services: any[]): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (!Services) {
        return null;
      }
      if (!isNaN(Number(control.value))) {
        return null;
      }
      if (!control.value) {
        return null;
      }

      const index = Services.findIndex(Service => {
        const escapedId = this.escapeRegExp(Service.value.toString());
        return new RegExp(`^${escapedId}$`).test(control.value);
      });
      return index < 0 ? { forbiddenNames: { value: control.value } } : null;
    };
  }




  escapeRegExp(input: string): string {
    return input.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  forbiddenIdValidator(Services: any[]): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (!control.value) {
        return null;
      }

      const index = Services.findIndex(Service => {
        const escapedId = this.escapeRegExp(Service.id.toString());
        return new RegExp(`^${escapedId}$`).test(control.value);
      });

      return index < 0 ? { forbiddenNames: { value: control.value } } : null;
    };
  }



  positiveRealNumberValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      const isValid = /^[1-9]\d*(\.\d+)?$/.test(value) || /^[1-9]\d*(\.\d+)?(\s*\/\s*[1-9]\d*(\.\d+)?)*$/.test(value);
      return isValid ? null : { positiveRealNumber: true };
    };
  }
  openImportWizardInventory(status: number = 1) {
    const dialogRef = this.dialog.open(ImportWizardInventoryComponent, {
      backdropClass: ['lgDialog'],
      disableClose: true,
      data: {
        inventoryWizardStatus: status,
        schemanName: this.schemaName,
        drugInfo: {
          genericName: this.drugCharacteristicsModel.genericName,
          strength: this.drugCharacteristicsModel.strength,
          unit: this.drugCharacteristicsModel.unitId,
          drugNumber: this.drugCharacteristicsModel.drugId,
          inventoryNumber: this.inventoryId
        }

      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.data) {
        this.getInventoryByNdc();
        this.inventoryId = 0;
      } else {
        console.log("not export", result);
      }
    });
  }
  openImportWizardPillID() {
    const dialogRef = this.dialog.open(ImportWizardPillIdDetailsComponent, {
      backdropClass: ['lgDialog'],
      disableClose: false,
      data: {
        //pillId: null
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
        //this.getDrugData();
    });
  }


  getCoating() {
    this.ngxLoader.start();
    this.rpoToolService.getCoating().subscribe({
      next: (result) => {
        this.listOfCoating = result.data;
        this.ngxLoader.stop();
      },
      error: (error) => this.errorHandlerService.handleError(error),
    });
  }
  getScoring() {
    this.ngxLoader.start();
    this.rpoToolService
      .getScoring()
      .subscribe({
        next: (result) => {
          this.listOfScoaring = result.data;
          this.ngxLoader.stop();
        },
        error: (error) => this.errorHandlerService.handleError(error),
      });
  }

  getPillType() {
    this.ngxLoader.start();
    this.rpoToolService
      .getPillType()
      .subscribe({
        next: (result) => {
          this.listOfPillType = result.data;
          this.ngxLoader.stop();
        },
        error: (error) => this.errorHandlerService.handleError(error),
      }
      );
  }

  getCountryList() {
    this.ngxLoader.start();
    this.rpoToolService
      .getCountryList()
      .subscribe(
        (result) => {
          this.countryList = result.data;
          this.ngxLoader.stop();
        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop();
          console.log(error);
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }

  getDrugClassificationType() {
    this.ngxLoader.start();
    this.rpoToolService
      .getDrugClassificationType()
      .subscribe(
        (result) => {
          this.listOfDrugClassificationType = result.data;
          this.ngxLoader.stop();
        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop();
          console.log(error);
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }
  getColorCodeByStatus(status: string | null): string {
    status = status?.trim();

    switch (status) {
      case 'Do Not Use':
        return '#f06616';           // Color for 'Do Not Use'
      case 'In Production-VS':
        return '#0352ba';
      case 'IN PRODUCTION':
        return '#0352ba';
      case 'IN PRODUCTION':
        return '#0352ba';          // Color for 'In Production-VS'
      case 'LabOptimized':
        return '#403E3E';
      case 'Non-Certified':
        return '#ffa54d';           // Color for 'Non-Certified'
      case '_':
      case null:
        return '';                  // No color for null or '_'
      default:
        return '#403E3E';           // Default light black color for other cases
    }
  }

  getDrugByndc() {
    this.rpoToolService.getDrugDetailsByNdc(this.ndc, this.dataSourceId).subscribe((response) => {
      let result = response.data
      this.drugName = result.medName;
      this.drugId = result.characteristics.id;
      this.schemaName = result.characteristics.schemaName;
      this.source = result.characteristics.source;
      this.otherBottleSizes = result.otherBottleSizes

      if (result.characteristics.source === 3) {
        this.isDisableEditForSource = false;
      }
      else {
        this.isDisableEditForSource = true;
      }

      //characteristics
      this.drugCharacteristicsModel.active = result.characteristics.active;
      this.drugCharacteristicsModel.genericName = result.characteristics.genericName;
      this.drugCharacteristicsModel.drugName = result.characteristics.primaryName;
      this.drugCharacteristicsModel.strength = result.characteristics.strength;
      this.drugCharacteristicsModel.gpi = result.characteristics.gpi;
      this.drugCharacteristicsModel.gcn = result.characteristics.gcn;
      this.drugCharacteristicsModel.countryCode = result.characteristics.countryCode;
      this.drugCharacteristicsModel.distributor = result.characteristics.distributor;
      this.drugCharacteristicsModel.distributorId = result.characteristics.distributorId;
      this.drugCharacteristicsModel.drugStatusId = result.characteristics.drugStatusId;
      this.drugCharacteristicsModel.unitId = result.characteristics.unitId;
      this.drugCharacteristicsModel.drugId = result.characteristics.drugId;
      this.drugCharacteristicsModel.schedule = result.characteristics.schedule;
      this.drugCharacteristicsModel.antibiotics = result.characteristics.antibiotics;
      this.drugCharacteristicsModel.dosageForm = result.characteristics.dosageForm;
      this.drugCharacteristicsModel.dosageFormId = result.characteristics.dosageFormId;
      this.drugCharacteristicsModel.manufacturer = result.characteristics.manufacturer;
      this.drugCharacteristicsModel.manufacturerId = result.characteristics.manufacturerId;
      this.drugCharacteristicsModel.niosh = result.characteristics.niosh;
      this.saveModelForm.controls.dnumber.setValue(result.characteristics.dnumber);
      this.drugCharacteristicsModel.otc = result.characteristics.otc;
      this.drugCharacteristicsModel.otcId = result.characteristics.otcId;
      this.drugCharacteristicsModel.packageSize = result.characteristics.packageSize;
      this.drugCharacteristicsModel.packaging = result.characteristics.packaging;
      this.drugCharacteristicsModel.roa = result.characteristics.roa;
      this.drugCharacteristicsModel.routeOfAdminId = result.characteristics.routeOfAdminId;
      this.drugCharacteristicsModel.storageConditions = result.characteristics.storageConditions;
      this.drugCharacteristicsModel.unitDose = result.characteristics.unitDose;
      this.drugCharacteristicsModel.unitOfUse = result.characteristics.unitOfUse;
      this.drugCharacteristicsModel.updated = result.characteristics.updated;
      this.drugCharacteristicsModel.drugStatus = result.characteristics.drugStatus;
      this.drugCharacteristicsModel.drugStatusColor = result.characteristics.drugStatusColor;
      this.drugCharacteristicsModel.quarantined = result.characteristics.quarantined;
      this.saveModelForm.controls.quarantineId.setValue(result.characteristics.quarantineId);
      this.saveModelForm.controls.shapeId.setValue(result.characteristics.shapeId);
      this.drugCharacteristicsModel.quarantinedColor = result.characteristics.quarantinedColor;
      this.drugCharacteristicsModel.quarantineReason = result.characteristics.quarantineReason;
      this.drugCharacteristicsModel.shapeId = result.characteristics.shapeId;
      this.drugCharacteristicsModel.quarantineId = result.characteristics.quarantineId;
      this.drugCharacteristicsModel.shape = result.characteristics.shape;
      this.images.serialImage = `data:image/png;base64,${result?.serialImage == undefined || result?.serialImage == null ? this.defaultImage : result?.serialImage}`;
      this.images.imageName = result.images?.imageName;
      // packages
      // this.saveModelForm.controls.packageBarcode.setValue(result.characteristics.barcode);
      // const barcode = result.characteristics.barcode2d?.includes('||') ? result.characteristics.barcode2d.split('||')[1] || null : result.characteristics.barcode2d;
      // this.saveModelForm.controls.packageBarcode2d.setValue(barcode);

      // Correctly set the UPC Barcode to the correct form control
      this.saveModelForm.controls.packageBarcode.setValue(result.characteristics.barcode ?? '');

      // Set 2D Barcode only if data is available; otherwise, keep it empty
      const barcode2D = result.characteristics.barcode2d?.includes('||')
        ? result.characteristics.barcode2d.split('||')[1] || null
        : result.characteristics.barcode2d;
      this.saveModelForm.controls.packageBarcode2d.setValue(barcode2D ?? '');
      this.saveModelForm.controls.packageThirtyDramCapacity.setValue(result.characteristics.thirtyDramCapacity);
      this.saveModelForm.controls.coatingId.setValue(result.characteristics.coatingId);
      this.saveModelForm.controls.packageImprint1.setValue(result.characteristics.imprint1);
      this.saveModelForm.controls.packageImprint2.setValue(result.characteristics.imprint2);
      this.saveModelForm.controls.packageDepth.setValue(result.characteristics.packageDepth);
      this.saveModelForm.controls.packageHeight.setValue(result.characteristics.packageHeight);
      this.saveModelForm.controls.packageWidth.setValue(result.characteristics.packageWidth);
      this.saveModelForm.controls.packageSize.setValue(result.characteristics.packageSize);
      this.saveModelForm.controls.packageTypeId.setValue(result.characteristics.packageTypeId);
      this.saveModelForm.controls.country.setValue(result.characteristics.countryCodeId);
      this.saveModelForm.controls.drugClassificationType.setValue(result.characteristics.drugNumberTypeId);

      this.saveModelForm.controls.length.setValue(result?.characteristics?.length == null ? 0 : result?.characteristics?.length);
      this.saveModelForm.controls.width.setValue(result?.characteristics?.width == null ? 0 : result?.characteristics?.width);
      this.saveModelForm.controls.thickness.setValue(result?.characteristics?.thickness == null ? 0 : result?.characteristics?.thickness);
      this.saveModelForm.controls.pieceWeight.setValue(result?.characteristics?.weight == null ? 0 : result?.characteristics?.weight);
      this.saveModelForm.controls.diagonal.setValue(result?.characteristics?.diagonal == null ? 0 : result?.characteristics?.diagonal);
      this.saveModelForm.controls.classificationShapeId.setValue(result?.characteristics?.classificationShapeId);
      //characteristics
      this.saveModelForm.controls.genericName.setValue(result.characteristics.genericName);
      this.saveModelForm.controls.storageConditions.setValue(result.characteristics.storageConditions);
      this.saveModelForm.controls.drugName.setValue(result.characteristics.primaryName);
      this.saveModelForm.controls.strength.setValue(result.characteristics.strength);
      this.saveModelForm.controls.unitId.setValue(result.characteristics.unitId);
      this.saveModelForm.controls.drugId.setValue(result.characteristics.drugId);
      this.saveModelForm.controls.active.setValue(result.characteristics.active);
      this.saveModelForm.controls.scheduleId.setValue(result.characteristics.scheduleId);
      this.saveModelForm.controls.manufacturerId.setValue(result.characteristics.manufacturerId);
      this.saveModelForm.controls.routeOfAdminId.setValue(result.characteristics.routeOfAdminId);
      this.saveModelForm.controls.distributorId.setValue(result.characteristics.distributorId);
      this.saveModelForm.controls.drugStatusId.setValue(result.characteristics.drugStatusId);
      this.saveModelForm.controls.otcId.setValue(result.characteristics.otcId);
      this.saveModelForm.controls.dosageFormId.setValue(result.characteristics.dosageFormId);
      this.saveModelForm.controls.niosh.setValue(result.characteristics.niosh);
      this.saveModelForm.controls.antibiotics.setValue(result.characteristics.antibiotics);
      const unitOfUse = result.characteristics.unitOfUse === 'No' ? '0' : result.characteristics.unitOfUse === 'Yes' ? '1' : null;
      const unitDose = result.characteristics.unitDose === 'No' ? '0' : result.characteristics.unitDose === 'Yes' ? '1' : null;
      this.saveModelForm.controls.unitOfUse.setValue(unitOfUse);
      this.saveModelForm.controls.unitDose.setValue(unitDose);
      this.saveModelForm.controls.scoringId.setValue(result.characteristics.scoringId);
      const gpi = (result.characteristics.gpi != null ? result.characteristics.gpi : '') +
        (result.characteristics.gcn != null ? result.characteristics.gcn : '');
      this.saveModelForm.controls.gpi.setValue(gpi.replace('--', ''));
      this.saveModelForm.controls.oralSolid.setValue(result.characteristics.oralSolid);

      // Color handling
      if (result.characteristics.color) {
        const color = result.characteristics.color;

        // If color contains '||', split it into two parts
        if (color?.includes('||')) {
          const [color1, color2] = color.split('||');

          // Check if either color is empty and set the selectedColors accordingly
          if (color1.trim() === '' || color2.trim() === '') {
            this.selectedColors = []; // Set to empty array if any color is empty
            this.colorId.setValue('');
          } else {
            this.selectedColors = [color2]; // Only set the second color (color2) as selected
            this.colorId.setValue(color2);
          }
        } else {
          // If color doesn't contain '||', handle as a single color
          if (color.trim() === '') {
            this.selectedColors = []; // Set to empty array if color is empty
            this.colorId.setValue('');
          } else {
            this.selectedColors = [color]; // Add the color to selectedColors
            this.colorId.setValue(color);
          }
        }
      }


      this.listOfDistributor.push({
        value: result.characteristics.distributorId,
        label: result.characteristics.distributor,
        description: ''
      });
      this.listOfDosageForm.push({
        id: result.characteristics.dosageFormId,
        description: result.characteristics.dosageForm,
      });

      this.listOfRoa.push({
        value: result.characteristics.routeOfAdminId,
        label: result.characteristics.roa,
        description: ''
      });

      this.listOfManufacturer.push({
        value: result.characteristics.manufacturerId,
        label: result.characteristics.manufacturer ,
        description: ''
      });

      this.drugNameId.setValue(result.characteristics.primaryName)
      this.drugNameId.updateValueAndValidity(); // Re-validate the form control

      if (result.characteristics.packageTypeId && result.characteristics.packaging) {
        this.listOfPackageType = [{
          value: result.characteristics.packageTypeId,
          label: result.characteristics.packaging,
          description: ''
        }];
      }

      result?.devices.forEach(element => {
        this.devicesModel.push({
          deviceName: element.deviceName,
          rateofUse: element.rateofUse,
          drugStatus: element.drugRecord?.replace('_', ' '),
          deviceStatus: element.deviceName === 'MAX' ? element.maxDrugStatus :
            element.deviceName === 'ATP' ? element.atpDrugStatus :
              element.deviceName === 'PASS' ? element.passDrugStatus :
                element.deviceName === 'SYNMED' ? element.synmedDrugStatus :
                  null,//element.deviceRecord?.replace('_', ' '),
          deviceStatusColor: element.deviceRecordColor,
          drugRecordColor: element.drugRecordColor,
          labOptimizedStatus: element.labOptimizedStatus
        })

        if (element.deviceName === 'PASS') {

          this.passModel.canisterId = element.canisterId;
          this.passModel.dnuReason = element.dnuReason;
          this.passModel.snapCanisterId = element.snapCanisterId;


          this.saveModelForm.controls.passDrugStatus.setValue(element.passDrugStatus);
          this.saveModelForm.controls.passLabOptimized.setValue(element.labOptimized);
        }
        else if (element.deviceName === 'MAX') {
          this.saveModelForm.controls.maxThirtyDramDnu.setValue(Number(element.thirtyDramDnu));
          this.saveModelForm.controls.maxDoNotUse.setValue(Number(element.doNotUse));
          this.saveModelForm.controls.maxDrugStatus.setValue(element.maxDrugStatus);
          this.saveModelForm.controls.maxCellHeight.setValue(element.cellHeight);
          this.saveModelForm.controls.maxCellWidth.setValue(element.cellWidth);
          this.saveModelForm.controls.maxBaffle.setValue(element.baffle);
          this.saveModelForm.controls.maxPressure.setValue(element.pressure);
          this.saveModelForm.controls.maxLabOptimized.setValue(element.labOptimized);
          this.saveModelForm.controls.cellCapacity.setValue(element.cellCapacity);
          this.saveModelForm.controls.superCellCapacity.setValue(element.superCellCapacity);
          this.saveModelForm.controls.isSuperCellOnly.setValue(element.isSuperCellOnly);
        }
        else if (element.deviceName === 'SYNMED') {
          this.saveModelForm.controls.massIndex.setValue(element.massIndex);
          this.saveModelForm.controls.lidHole.setValue(element.lidHoleSize);
          this.saveModelForm.controls.lidVolcanic.setValue(element.lidVolcanic);
          this.saveModelForm.controls.fragileFlag.setValue(element.fragileFlag);
          this.saveModelForm.controls.toggle.setValue(element.toggleFlag);
          this.saveModelForm.controls.synmedDrugStatus.setValue(element.synmedDrugStatus);
          this.saveModelForm.controls.containerSize.setValue(element.containerSize);
          this.saveModelForm.controls.pipetteSize.setValue(element.pipetteSize);
          this.saveModelForm.controls.synmedLabOptimized.setValue(element.labOptimized);
          this.saveModelForm.controls.nonCountReasonId.setValue(element.nonCountReasonId);
          this.saveModelForm.controls.preferredLidHoleSize.setValue(element.preferredLidHoleSize);
          this.saveModelForm.controls.preferredContainerSize.setValue(element.preferredContainerSize);
          this.saveModelForm.controls.preferredPipetteSize.setValue(element.preferredPipetteSize);
          this.saveModelForm.controls.largePipetteDropHeight.setValue(element.largePipetteDropHeight);
          this.saveModelForm.controls.smallPipetteDropHeight.setValue(element.smallPipetteDropHeight);
        }
        else if (element.deviceName === 'ATP') {
          this.saveModelForm.controls.atpDrugStatus.setValue(element.atpDrugStatus);
          this.saveModelForm.controls.atpTcgDiameter.setValue(element.tcgDiameter)
          this.saveModelForm.controls.atpTcgPillType.setValue(element.tcgPillType)
          this.saveModelForm.controls.atpTcgPillVolume.setValue(element.tcgPillVolume)
          this.saveModelForm.controls.atpTcgT1.setValue(element.tcgT1)
          this.saveModelForm.controls.atpTcgT2.setValue(element.tcgT2)
          this.saveModelForm.controls.atpTcgWidth.setValue(element.tcgWidth)
          this.saveModelForm.controls.atpTcgLength.setValue(element.tcgLength)
          this.saveModelForm.controls.atpCanisterNumber.setValue(element.canisterNumber)
          this.saveModelForm.controls.atpLabOptimized.setValue(element.labOptimized);
          this.saveModelForm.controls.canisterCapacity.setValue(element.canisterCapacity);
          this.saveModelForm.controls.highCapCapacity.setValue(element.highCapCapacity);

        }
      });
      let count = 0;
      let dataBindInterval = setInterval(() => {


        count++;
        if (count === 2) {
          this.dataSourceDevice.data = this.devicesModel
          clearInterval(dataBindInterval)
          this.ngxLoader.stop();
        }
      }, 500)

      setTimeout(() => {
        this.getInventoryByNdc();
      }, 0)
    },
      (error: HttpErrorResponse) => {
        this.ngxLoader.stop();
        console.log(error);
        this.toastService.openToast(error.error.message === undefined ?
          'Something went wrong!!' : error.error.message,
          constants.ToastPanelType.error,
          2
        );
      })
  }
  getDistributor(search) {
    if (search?.length == 0) {
      return;
    }
    this.isLoading = true;
    this.rpoToolService
      .getDistributor(search)
      .subscribe(
        (result) => {
          this.listOfDistributor = result.data;
          this.isLoading = false;
          this.distributorId.setValidators([
            this.forbiddenNamesValidator(this.listOfDistributor)
          ]);
          this.distributorId.updateValueAndValidity();
        },
        (error: HttpErrorResponse) => {
          this.isLoading = false;
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }

  getDosageForm(search) {
    if (search?.length == 0) {
      return;
    }
    this.isLoading = true;
    this.rpoToolService
      .getDosageForm(search)
      .subscribe(
        (result) => {
          this.listOfDosageForm = result.data;
          this.isLoading = false;
          this.dosageFormId.setValidators([
            this.forbiddenIdValidator(this.listOfDosageForm)
          ]);
          this.dosageFormId.updateValueAndValidity();
        },
        (error: HttpErrorResponse) => {
          this.isLoading = false;
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }

  getRoa(search) {
    if (search?.length == 0) {
      return;
    }
    this.isLoading = true;
    this.rpoToolService
      .getRouteOfAdministration(search)
      .subscribe(
        (result) => {
          this.listOfRoa = result.data;
          this.isLoading = false;
          this.routeOfAdminId.setValidators([
            this.forbiddenNamesValidator(this.listOfRoa)
          ]);
          this.routeOfAdminId.updateValueAndValidity();
        },
        (error: HttpErrorResponse) => {
          this.isLoading = false;
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }

  getNiosh() {
    this.rpoToolService
      .getNiosh()
      .subscribe(
        (result) => {
          this.listOfNiosh = result.data;
        },
        (error: HttpErrorResponse) => {
          console.log(error);
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }

  getManufacture(search) {
    if (search?.length == 0) {
      return;
    }
    this.isLoading = true;
    this.rpoToolService
      .getManufacture(search)
      .subscribe(
        (result) => {
          this.listOfManufacturer = result.data;
          this.isLoading = false;
          this.manufacturerId.setValidators([
            this.forbiddenNamesValidator(this.listOfManufacturer)
          ]);
          this.manufacturerId.updateValueAndValidity();
        },
        (error: HttpErrorResponse) => {
          this.isLoading = false;
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }

  getDrugName(search) {
    if (search?.length == 0) {
      return;
    }
    this.isLoading = true;
    this.rpoToolService
      .getDrugName(search)
      .subscribe(
        (result) => {
          this.listOfDrugName = result.data;
          this.isLoading = false;
        },
        (error: HttpErrorResponse) => {
          this.isLoading = false;
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }



  getGenericName(search) {
    if (search?.length == 0) {
      return;
    }
    this.isLoading = true;
    this.rpoToolService
      .getGenericName(search)
      .subscribe(
        (result) => {
          this.listOfGenericName = result.data;
          this.isLoading = false;
        },
        (error: HttpErrorResponse) => {
          this.isLoading = false;
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }


  getColor(search) {
    this.rpoToolService
      .getColor(search)
      .subscribe(
        (result) => {
          this.listOfColor = result.data;
          this.allColors = this.listOfColor.map(color => String(color.label));
        },
        (error: HttpErrorResponse) => {
          console.log(error);
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }

  getPackageType(value) {
    this.isLoading = true;
    this.rpoToolService
      .getPackageType(value)
      .subscribe(
        (result) => {
          this.listOfPackageType = result.data;
          this.isLoading = false;

          this.packageTypeId.setValidators([
            this.forbiddenNamesValidator(this.listOfPackageType)
          ]);
          this.packageTypeId.updateValueAndValidity();
        },
        (error: HttpErrorResponse) => {
          this.isLoading = false;
          console.log(error);
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }

  getOtc() {
    this.ngxLoader.start();
    this.rpoToolService
      .getOtc()
      .subscribe({
        next: (result) => {
          this.listOfOTC = result.data;
          this.ngxLoader.stop();
        },
        error: (error) => this.errorHandlerService.handleError(error),
      });
  }


  getQuarantineReasonList() {
    this.ngxLoader.start();
    this.rpoToolService
      .getQuarantineReasonList()
      .subscribe(
        (result) => {
          this.quarantineReasonList = result.data;
          this.ngxLoader.stop();
        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop();
          console.log(error);
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }

  getShapeList() {
    this.ngxLoader.start();
    this.rpoToolService
      .getPillShapeList()
      .subscribe(
        (result) => {
          this.shapeList = result.data;
          this.ngxLoader.stop();
        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop();
          console.log(error);
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }

  getDrugNonCountReasonList() {
    this.ngxLoader.start();
    this.rpoToolService
      .getDrugNonCountReasonList()
      .subscribe(
        (result) => {
          this.listOfDnuReason = result.data;
          this.ngxLoader.stop();
        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop();
          console.log(error);
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }
  toggleCanisterDetails(isCanister: boolean, isSnapCanister: boolean) {
    // Check if canister details are already shown
    if (!this.isCanisterDetails) {
      this.GetDrugByClassificationIdAndNdc(isCanister, isSnapCanister);
    }
    // Toggle the state of canister details
    this.isCanisterDetails = !this.isCanisterDetails;
  }

  toggleSnapCanisterDetails(isCanister: boolean, isSnapCanister: boolean) {
    // Check if snap canister details are already shown
    if (!this.isSnapCanisterDetails) {
      this.GetDrugByClassificationIdAndNdc(isCanister, isSnapCanister);
    }
    // Toggle the state of snap canister details
    this.isSnapCanisterDetails = !this.isSnapCanisterDetails;
  }


  GetDrugByClassificationIdAndNdc(isCanisterDetails: boolean, isSnapCanisterDetails: boolean) {
    const formValue = this.saveModelForm.value;

    // Reset data source and show loader
    this.dataSource = [];
    this.ngxLoader.start();

    // Call the service to fetch data
    this.rpoToolService.GetDrugByClassificationIdAndNdc(formValue.classificationShapeId, this.ndc)
      .subscribe(
        (response) => {
          this.ngxLoader.stop();  // Stop loader on response

          // Check if data exists
          if (response?.data) {
            const result = response.data;
            console.log(result)
            // Populate dataSource with response data
            this.dataSource = [
              { partType: 'DItems', part: result.passDItem, partNo: '' },
              { partType: 'Canister No', part: result.canisterRecipe, partNo: '' },
              { partType: 'Brush', part: result.snapBrushPart, partNo: result.snapBrush },
              { partType: 'Division Block', part: result.snapDivisionBlockPart, partNo: result.snapDivBlock },
              { partType: 'Gel Pad', part: result.snapGelPadPart, partNo: result.snapGelPadPartNo },
              { partType: 'Guide Block', part: result.snapGuideBlockPart, partNo: result.snapGuideBlock },
              { partType: 'Handle', part: result.handlePart, partNo: result.handlePartNo },
              { partType: 'Slot Location', part: result.slotLocationPart, partNo: result.slotLocationPartNo },
            ];

            // Update component state
            this.isCanisterDetails = isCanisterDetails;
            this.isSnapCanisterDetails = isSnapCanisterDetails;
          } else {
            // Handle empty data response
            this.toastService.openToast(
              response.message || 'No data found!',
              constants.ToastPanelType.warning,
              2
            );
          }
        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop();  // Ensure loader stops on error

          // Log the error for debugging
          console.error('Error fetching drug details:', error);

          // Display user-friendly error message
          this.toastService.openToast(
            error.error?.message || 'Something went wrong!',
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }
  getRecommendedDrug() {

    const formValue = this.saveModelForm.value;
    if ((formValue.length == 0 || formValue.length == null) || (formValue.width == 0 || formValue.width == null) || (formValue.classificationShapeId == null || formValue.classificationShapeId == undefined || formValue.classificationShapeId == 0)) {
      this.toastService.openToast('Match not available... missing Length, width or shape',
        constants.ToastPanelType.warning,
        2
      );
      return;
    }
    this.ngxLoader.start();
    this.rpoToolService
      .getRecommendedDrug(formValue.length, formValue.width, formValue.thickness, formValue.pieceWeight, formValue.diagonal, formValue.classificationShapeId)
      .subscribe(
        (response) => {
          let result = response.data;
          this.canisterData = [];
          this.usersData = [];
          result.forEach((element: any) => {
            this.canisterData.push({
              canisterRecipe: this.saveModelForm.value.recommendationType == '1' ? element.canisterRecipe : element.snapRecipe,
              snapRecipe: element.snapRecipe,
              dItem: this.saveModelForm.value.recommendationType == '1' ? element.passDItem : element.snapDItem,
              matchLevel: element.matchLevel,
              medName: element.medName,
              canisters: [{
                length: element.length,
                width: element.width,
                diagonal: element.diagonal,
                pillType: element.pillType,
                pieceWeight: element.pieceWeight,
                thickness: element.thickness,
                snapBody: element.snapBody,
                snapBrush: element.snapBrush,
                snapBrushBlock: element.snapBrushBlock,
                snapDivBlock: element.snapDivBlock,
                snapGuideBlock: element.snapGuideBlock,
                slotLocation: element.slotLocation,
                divisionBlock: element.divisionBlock,
                brushId: element.brushId,
                gelPadId: element.gelPadId,
                handleIdId: element.handleIdId,
                guideBlock: element.guideBlock,
                weight: element.weight,
                handlePartNo: element.handlePartNo,
                handlePart: element.handlePart,
                slotLocationPartNo: element.slotLocationPartNo,
                slotLocationPart: element.slotLocationPart,
                snapDivisionBlockPart: element.snapDivisionBlockPart,
                snapGuideBlockPart: element.snapGuideBlockPart,
                snapGelPadPartNo: element.snapGelPadPartNo,
                snapGelPadPart: element.snapGelPadPart,
                snapBrushPart: element.snapBrushPart
              }]
            })
          });

          this.canisterData.forEach(user => {
            if (user.canisters && Array.isArray(user.canisters) && user.canisters.length) {
              this.usersData = [...this.usersData, { ...user, canisters: new MatTableDataSource(user.canisters) }];
            } else {
              this.usersData = [...this.usersData, user];
            }
          });
          this.dataSourceRecommendationDrug = new MatTableDataSource(this.usersData);
          this.isRecommendedShow = true;
          this.ngxLoader.stop();

        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop();
          console.log(error);
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }

  getDrugByCanisterIdOrSnapCanisterId() {

    const formValue = this.saveModelForm.value;
    if ((formValue.length == 0 || formValue.length == null) || (formValue.width == 0 || formValue.width == null) || (formValue.classificationShapeId == null || formValue.classificationShapeId == undefined || formValue.classificationShapeId == 0)) {
      this.toastService.openToast('Match not available... missing Length, width or shape',
        constants.ToastPanelType.warning,
        2
      );
      return;
    }
    this.ngxLoader.start();
    this.rpoToolService
      .getRecommendedDrug(formValue.length, formValue.width, formValue.thickness, formValue.pieceWeight, formValue.diagonal, formValue.classificationShapeId)
      .subscribe(
        (response) => {
          let result = response.data;
          this.canisterData = [];
          this.usersData = [];
          result.forEach((element: any) => {
            this.canisterData.push({
              canisterRecipe: this.saveModelForm.value.recommendationType == '1' ? element.canisterRecipe : element.snapRecipe,
              snapRecipe: element.snapRecipe,
              dItem: this.saveModelForm.value.recommendationType == '1' ? element.passDItem : element.snapDItem,
              matchLevel: element.matchLevel,
              medName: element.medName,
              canisters: [{
                length: element.length,
                width: element.width,
                diagonal: element.diagonal,
                pillType: element.pillType,
                pieceWeight: element.pieceWeight,
                thickness: element.thickness,
                snapBody: element.snapBody,
                snapBrush: element.snapBrush,
                snapBrushBlock: element.snapBrushBlock,
                snapDivBlock: element.snapDivBlock,
                snapGuideBlock: element.snapGuideBlock,
                slotLocation: element.slotLocation,
                divisionBlock: element.divisionBlock,
                brushId: element.brushId,
                gelPadId: element.gelPadId,
                handleIdId: element.handleIdId,
                guideBlock: element.guideBlock,
                weight: element.weight,
                handlePartNo: element.handlePartNo,
                handlePart: element.handlePart,
                slotLocationPartNo: element.slotLocationPartNo,
                slotLocationPart: element.slotLocationPart,
                snapDivisionBlockPart: element.snapDivisionBlockPart,
                snapGuideBlockPart: element.snapGuideBlockPart,
                snapGelPadPartNo: element.snapGelPadPartNo,
                snapGelPadPart: element.snapGelPadPart,
                snapBrushPart: element.snapBrushPart

              }]
            })
          });

          this.canisterData.forEach(user => {
            if (user.canisters && Array.isArray(user.canisters) && user.canisters.length) {
              this.usersData = [...this.usersData, { ...user, canisters: new MatTableDataSource(user.canisters) }];
            } else {
              this.usersData = [...this.usersData, user];
            }
          });
          this.dataSourceRecommendationDrug = new MatTableDataSource(this.usersData);
          this.isRecommendedShow = true;
          this.ngxLoader.stop();

        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop();
          console.log(error);
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }

  getClassificationShape() {
    this.ngxLoader.start();
    this.rpoToolService
      .getClassificationShape()
      .subscribe(
        (result) => {
          this.listOfClassificationShape = result.data;
          this.ngxLoader.stop();
        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop();
          console.log(error);
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }
  getInventoryByNdc() {
    this.ngxLoader.start();
    this.rpoToolService
      .getInventoryByNDC(this.drugCharacteristicsModel.drugId)
      .subscribe(

        (response) => {
          let result = response.data
          this.inventoryList = [];
          result.forEach((element: any) => {
            this.inventoryList.push({
              id: element.id,
              inventoryNumber: element.id,
              addedDate: element.date,
              owner: element.changedDate,
              inventoryQuantity: element.quantity,
              lastChangedDate: element.changedDate,
              isDestroyed: element.destroyed,
              destroyDate: element.destroyedDate,
              destroyedBy: element.destroyedBy,
              destroyedComments: element.destroyedComments,
              price: element.price,
              source: element.source,
              sourceAddress: element.sourceAddress,
              sourcePhone: element.sourcePhone,
              sourceEmail: element.sourceEmail,
              comments: element.comments,
            });
          });

          this.ngxLoader.stop();

        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop();
          console.log(error);
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }
  openImportWizardImageSlide() {

    const dialogRef = this.dialog.open(ImportWizardImageSlideComponent, {
      backdropClass: ['mdDialog'],
      disableClose: true,
      data: { ndc: this.drugCharacteristicsModel.drugId }
    });
  }


  saveCanister() {
    if (this.saveModelForm.value.recommendationType == 1) {
      this.canisterId = this.passModel.canisterId;
      this.passModel.canisterId = this.assignCanisterModel.canisterRecipe;
    }
    else if (this.saveModelForm.value.recommendationType == 2) {
      this.snapCanisterId = this.passModel.snapCanisterId;
      this.passModel.snapCanisterId = this.assignCanisterModel.snapRecipe;
    }
    this.isRecommendedShow = false;


  }

  cancelSletectedCanisterId() {
    this.isRecommendedShow = false;
    if (this.canisterId) {
      this.passModel.canisterId = this.canisterId;
    }
    if (this.snapCanisterId) {
      this.passModel.snapCanisterId = this.snapCanisterId;
    }
    this.assignCanisterModel = {};
  }

  updateDrug() {
    if (!this.saveModelForm?.valid)
      return;
    if (!(this.saveModelForm.get('length').value >= this.saveModelForm.get('width').value && this.saveModelForm.get('width').value >= this.saveModelForm.get('thickness').value)) {
      this.openAlertWindow('Warning', 'Invalid input: Length must be greater than Width, and Width must be greater than Thickness')
      return;
    }
    if (this.saveModelForm.get('quarantineId').value != 6) {
      this.drugInforUpdateApi()
    }
    else if (this.saveModelForm.get('quarantineId').value == 6) {
      this.openAlertWindow('Warning', 'Are you sure you want to set this as a permanent quarantine drug?')
    }

  }
  drugInforUpdateApi() {
    const formValue = this.saveModelForm.value;
    this.drugUpdateModel = {
      classificationShapeId: formValue.classificationShapeId,
      length: formValue.length,
      dnumber: formValue.dnumber,
      width: formValue.width,
      thickness: formValue.thickness,
      weight: formValue.pieceWeight,
      diagonal: formValue.diagonal,
      ndc: this.drugCharacteristicsModel.drugId,
      packageBarcode: formValue.packageBarcode,
      packageBarcode2d: formValue.packageBarcode2d,
      packageThirtyDramCapacity: formValue.packageThirtyDramCapacity,
      coatingId: formValue.coatingId,
      packageImprint1: formValue.packageImprint1,
      packageImprint2: formValue.packageImprint2,
      color: this.selectedColors.join(','),
      scoringId: formValue.scoringId,
      maxThirtyDramDnu: formValue.maxThirtyDramDnu,
      maxDoNotUse: formValue.maxDoNotUse,
      maxDrugStatus: formValue.maxDrugStatus,
      maxCellHeight: formValue.maxCellHeight,
      maxCellWidth: formValue.maxCellWidth,
      maxBaffle: formValue.maxBaffle,
      maxPressure: formValue.maxPressure,
      atpDrugStatus: formValue.atpDrugStatus,
      atpTcgDiameter: formValue.atpTcgDiameter,
      atpTcgPillType: formValue.atpTcgPillType,
      atpTcgPillVolume: formValue.atpTcgPillVolume,
      atpTcgT1: formValue.atpTcgT1,
      atpTcgT2: formValue.atpTcgT2,
      atpCanisterNumber: formValue.atpCanisterNumber,
      atpLabOptimized: formValue.atpLabOptimized,
      synmedIsLabOptimized: formValue.synmedLabOptimized,
      passIsLabOptimized: formValue.passLabOptimized,
      maxIsLabOptimized: formValue.maxLabOptimized,
      atpIsLabOptimized: formValue.atpLabOptimized,
      passDrugStatus: formValue.passDrugStatus,
      passCanisterNumber: this.passModel.canisterId,
      passSnapCanisterNumber: this.passModel.snapCanisterId,
      massIndex: formValue.massIndex,
      lidHoleSize: formValue.lidHole,
      lidVolcanic: formValue.lidVolcanic,
      fragileFlag: formValue.fragileFlag,
      toggleFlag: formValue.toggle,
      pipetteSize: formValue.pipetteSize,
      source: this.source,
      id: this.drugId,
      schemaName: this.schemaName,
      distributorId: formValue.distributorId,
      packageSize: formValue.packageSize,
      packageDepth: formValue.packageDepth,
      packageHeight: formValue.packageHeight,
      packageTypeId: formValue.packageTypeId === "" ? null : formValue.packageTypeId,
      packageWidth: formValue.packageWidth,
      countryCodeId: formValue.country,
      drugNumberTypeId: formValue.drugClassificationType,
      oralSolid: formValue.oralSolid,
      synmedDrugStatus: formValue.synmedDrugStatus,
      cellCapacity: formValue.cellCapacity,
      superCellCapacity: formValue.superCellCapacity,
      canisterCapacity: formValue.canisterCapacity,
      highCapCapacity: formValue.highCapCapacity,
      quarantineId: formValue.quarantineId,
      shapeId: formValue.shapeId,

      nonCountReasonId: formValue.nonCountReasonId,
      largePipetteDropHeight: formValue.largePipetteDropHeight,
      smallPipetteDropHeight: formValue.smallPipetteDropHeight,
      preferredLidHoleSize: formValue.preferredLidHoleSize,
      preferredContainerSize: formValue.preferredContainerSize,
      preferredPipetteSize: formValue.preferredPipetteSize,
      smallCanisterCapacity: formValue.smallCanisterCapacity,
      largeCanisterCapacity: formValue.largeCanisterCapacity,
      //characteristics
      genericName: formValue.genericName,
      strength: formValue.strength,
      unitId: formValue.unitId,
      drugId: formValue.drugId,
      active: formValue.active,
      scheduleId: formValue.scheduleId,
      manufacturer: formValue.manufacturer,
      routeOfAdminId: formValue.routeOfAdminId,
      dosageFormId: formValue.dosageFormId,
      otc: formValue.otc,
      dosageForm: formValue.dosageForm,
      niosh: formValue.niosh,
      antibiotics: formValue.antibiotics,
      unitOfUse: formValue.unitOfUse,
      unitDose: formValue.unitDose,
      updated: formValue.updatedate,
      storageConditions: formValue.storageConditions,
      gpi: formValue.gpi,
      gcn: formValue.gcn,
      shape: formValue.shape,
      drugName: formValue.drugNameId,
      manufacturerId: formValue.manufacturerId,
      drugNameId: 1,
      drugStatusId: formValue.drugStatusId,
      otcId: formValue.otcId,
      isSuperCellOnly: formValue.isSuperCellOnly,
    };
    this.ngxLoader.start();
    this.rpoToolService
      .updateDrug(this.drugUpdateModel)
      .subscribe(
        (result) => {
          this.ngxLoader.stop();
          if (result.statusCode === 200) {
            this.toastService.openToast(
              result.message,
              constants.ToastPanelType.done,
              2
            );
            setTimeout(() => {
              this.clearFormData();
            }, 500)


          } else {
            this.toastService.openToast(
              result.message,
              constants.ToastPanelType.error,
              2
            );
          }
        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop();
          console.log(error);
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }
  getPassDrugStatus() {
    this.ngxLoader.start();
    this.rpoToolService
      .getPassDrugStatus()
      .subscribe(
        (result) => {
          this.listOfPASSDrugStatus = result.data;
          this.ngxLoader.stop();
        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop();
          console.log(error);
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }
  getMaxDrugStatus() {
    this.ngxLoader.start();
    this.rpoToolService
      .getMaxDrugStatus()
      .subscribe(
        (result) => {
          this.listOfMAXDrugStatus = result.data;
          this.ngxLoader.stop();
        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop();
          console.log(error);
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }



  getSynmedDrugStatus() {
    this.ngxLoader.start();
    this.rpoToolService
      .getSynmedDrugStatus()
      .subscribe(
        (result) => {
          this.listOfSynmedDrugStatus = result.data;
          this.ngxLoader.stop();
        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop();
          console.log(error);
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }
  getAtpDrugStatus() {
    this.ngxLoader.start();
    this.rpoToolService
      .getAtpDrugStatus()
      .subscribe(
        (result) => {
          this.listOfATPDrugStatus = result.data;
          this.ngxLoader.stop();
        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop();
          console.log(error);
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }
  clearFormData() {

    this.saveModelForm.reset();
    this.closeDialog(true);
  }
  closeDialog(response: boolean) {
    this.dialogRef.close({ event: 'close', data: response })
  }
  hasSynmedRequiredValues(): boolean {
    try {
      const fields = ['length', 'width', 'thickness', 'pieceWeight', 'packageThirtyDramCapacity'];
      return fields.every(field => {
        const control = this.saveModelForm.get(field);
        const value = control?.value;
        return value !== null && value !== undefined && value !== '' && !isNaN(Number(value));
      });
    } catch (error) {
      console.error('Error checking Synmed values:', error);
      return false;
    }
  }
  hasMaxRequiredValues(): boolean {
    try {
      // The MAX calculation requires these five inputs.
      const fields = ['pieceWeight', 'packageThirtyDramCapacity', 'width', 'thickness', 'classificationShapeId'];
      return fields.every(field => {
        const control = this.saveModelForm.get(field);
        const value = control?.value;
        return value !== null && value !== undefined && value !== '' && !isNaN(Number(value));
      });
    } catch (error) {
      console.error('Error checking MAX values:', error);
      return false;
    }
  }
  calculateMaxValues(): void {
    if (!this.saveModelForm || this.isMaxCalculating) return;
    if (!this.hasMaxRequiredValues()) return;

    this.isMaxCalculating = true;

    // Gather the five core input values from the form.
    const weight = Number(this.saveModelForm.get('pieceWeight')?.value);
    const thirtyDramCapacity = Number(this.saveModelForm.get('packageThirtyDramCapacity')?.value);
    const widthInput = Number(this.saveModelForm.get('width')?.value);
    const thickness = Number(this.saveModelForm.get('thickness')?.value);
    const classificationShapeId = Number(this.saveModelForm.get('classificationShapeId')?.value);

    const request = {
      Weight: weight,
      ThirtyDramCapacity: thirtyDramCapacity,
      Width: widthInput,
      Thickness: thickness,
      ClassificationShapeId: classificationShapeId
    };

    console.log('MAX calculation request:', request);

    this.rpoToolService.calculateMaxValues(request).subscribe({
      next: (response) => {
        console.log('MAX calculation response:', response);
        if (response.succeed && this.saveModelForm) {
          // Patch the form controls with the calculated values from the API.
          this.saveModelForm.patchValue({
            maxCellHeight: response.data.height,          // API height → maxCellHeight
            maxCellWidth: response.data.width,              // API width  → maxCellWidth
            maxPressure: response.data.pressure,            // API pressure → maxPressure
            maxBaffle: response.data.baffle,                // API baffle → maxBaffle
            cellCapacity: response.data.cellCapacity,       // API cellCapacity
            superCellCapacity: response.data.superCellCapacity // API superCellCapacity
          }, { emitEvent: false });
        }
      },
      error: (error) => {
        console.error('Error calculating MAX values:', error);
        this.toastService.openToast('Error calculating MAX values', constants.ToastPanelType.error, 2);
      },
      complete: () => {
        this.isMaxCalculating = false;
      }
    });
  }


  calculateSynmedValues() {
    if (!this.saveModelForm || this.isSynmedCalculating) return;

    try {
      const length = Number(this.saveModelForm.get('length')?.value);
      const width = Number(this.saveModelForm.get('width')?.value);
      const thickness = Number(this.saveModelForm.get('thickness')?.value);
      const pieceWeight = Number(this.saveModelForm.get('pieceWeight')?.value);
      const thirtyDramCapacity = Number(this.saveModelForm.get('packageThirtyDramCapacity')?.value);

      if ([length, width, thickness, pieceWeight, thirtyDramCapacity].some(v => isNaN(v))) {
        return;
      }

      // Start loader
      this.isSynmedCalculating = true;

      const request = {
        Length: length,
        Width: width,
        Thickness: thickness,
        PieceWeight: pieceWeight,
        ThirtyDramCapacity: thirtyDramCapacity
      };

      console.log('Synmed calculation request:', request);

      this.rpoToolService.calculateSynmedValues(request).subscribe({
        next: (response) => {
          console.log('Synmed calculation response:', response);
          if (response.succeed && this.saveModelForm) {
            this.saveModelForm.patchValue({
              preferredLidHoleSize: response.data.preferredLidHoleSize,
              preferredPipetteSize: response.data.preferredPipetteSize,
              preferredContainerSize: response.data.preferredContainerSize,
              useBothCanisters: response.data.useBothCanisters,
              lidVolcanic: response.data.lidVolcanic,
              massIndex: response.data.massIndex,
              massIndexConcat: response.data.massIndexConcat,
              pipetteDropHeight: response.data.pipetteDropHeight,
              smallPipetteDropHeight: response.data.smallPipetteDropHeight,
              largePipetteDropHeight: response.data.largePipetteDropHeight,
              smallCanisterCapacity: response.data.smallContainerCapacity,
              largeCanisterCapacity: response.data.largeContainerCapacity
            }, { emitEvent: false });
          }
        },
        error: (error) => {
          console.error('Synmed calculation error:', error);
          this.toastService.openToast(
            'Error calculating Synmed values',
            constants.ToastPanelType.error,
            2
          );
        },
        complete: () => {
          this.isSynmedCalculating = false;
        }
      });
    } catch (error) {
      console.error('Error in calculateSynmedValues:', error);
      this.isSynmedCalculating = false;
    }
  }

  calculateTcgValues() {
    if (!this.saveModelForm || this.isTcgCalculating) return;

    try {
      const thirtyDramCapacity = Number(this.saveModelForm.get('packageThirtyDramCapacity')?.value);

      if (isNaN(thirtyDramCapacity)) return;

      this.isTcgCalculating = true;
      const request = {
        ThirtyDramCapacity: thirtyDramCapacity
      };

      this.rpoToolService.calculateTcgValues(request).subscribe({
        next: (response) => {
          if (response.succeed && this.saveModelForm) {
            this.saveModelForm.patchValue({
              canisterCapacity: response.data.canisterCapacity,
              highCapCapacity: response.data.highCapCanisterCapacity
            }, { emitEvent: false });
          }
        },
        error: (error) => {
          console.error('TCG calculation error:', error);
          this.toastService.openToast(
            'Error calculating TCG values',
            constants.ToastPanelType.error,
            2
          );
        },
        complete: () => {
          this.isTcgCalculating = false;
        }
      });
    } catch (error) {
      console.error('Error in calculateTcgValues:', error);
      this.isTcgCalculating = false;
    }
  }
  setupFormWatchers() {
    setTimeout(() => {
      const synmedFields = ['length', 'width', 'thickness', 'pieceWeight', 'packageThirtyDramCapacity'];
      synmedFields.forEach(field => {
        this.saveModelForm.get(field)?.valueChanges
        .pipe(
            debounceTime(500)
        )
        .subscribe(() => {
            if (this.hasSynmedRequiredValues()) {
              this.calculateSynmedValues();
            }
        });
      });

      this.saveModelForm.get('packageThirtyDramCapacity')?.valueChanges
      .pipe(
        debounceTime(500)
      )
      .subscribe(() => {
          const value = this.saveModelForm.get('packageThirtyDramCapacity')?.value;
          if (value) {
              this.calculateTcgValues();
          }

      });

    // NEW: MAX watchers – use the five base fields for MAX calculation.
    const maxFields = ['pieceWeight', 'packageThirtyDramCapacity', 'width', 'thickness', 'classificationShapeId'];
    maxFields.forEach(field => {
        this.saveModelForm.get(field)?.valueChanges
        .pipe(
            debounceTime(500)
        )
        .subscribe(() => {
            if (this.hasMaxRequiredValues()) {
              this.calculateMaxValues();
            }
        });
    });

    }, 1000);
  }

  openAlertWindow(title: string, message: string, btnCancel: string = 'Cancel', btnConfirm: string = 'Confirm'): any {
    let output = false;
    const dialogRef = this.dialog.open(ImportWizardAlertComponent, {
      backdropClass: ['smDialog'],
      disableClose: true,
      data: {
        alertIcon: "/assets/img/icons/ico.16.warning.svg",
        title: title,
        bodyMessage: message,
        bodyMessage2: "",
        cancelBtnText: btnCancel,
        confirmBtnText: btnConfirm,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.data === true) {
        this.drugInforUpdateApi()
      } else {
        console.log("Cancle", result);
        output = result.data;
      }
    });
    return output;
  }

  AttributeValidation(controlName: string, event: any) {
    const value = event.target.value;
    //const control = this.form.get(controlName);
    console.log(value);
    if (controlName === 'maxCellHeight') {
      if (!this.validHeights.includes(parseFloat(value))) {
        this.toastService.openToast("Invalid Max Cell Height",
          constants.ToastPanelType.error,
          2
        );
        this.saveModelForm.controls.maxCellHeight.setValue(null);
      }
    }
    else if (controlName === 'maxCellWidth') {
      if (!this.validWidths.includes(value)) {
        this.toastService.openToast("Invalid Max Cell Width! Please enter a value like A.00, A.25, etc.",
          constants.ToastPanelType.error,
          2
        );
        this.saveModelForm.controls.maxCellWidth.setValue('');
      }
    }
    else if (controlName === 'maxBaffle') {
      if (!this.validBaffles.includes(parseInt(value))) {
        this.toastService.openToast("Invalid Baffle value.",
          constants.ToastPanelType.error,
          2
        );
        this.saveModelForm.controls.maxBaffle.setValue(null);
      }
    }
    else if (controlName === 'maxPressure') {
      if (!this.validPressures.includes(parseInt(value))) {
        this.toastService.openToast("Invalid Pressure value.",
          constants.ToastPanelType.error,
          2
        );
        this.saveModelForm.controls.maxPressure.setValue(null);
      }
    }
  }

  getScheduleList() {
    this.ngxLoader.start();
    this.rpoToolService
      .getScheduleList()
      .subscribe(
        (result) => {
          this.scheduleList = result.data;
          this.ngxLoader.stop();
        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop();
          console.log(error);
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }

  getUnitList() {
    this.ngxLoader.start();
    this.rpoToolService
      .getUnit('')
      .subscribe(
        (result) => {
          this.unitList = result.data;
          this.ngxLoader.stop();
        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop();
          console.log(error);
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }
  getCommonDrugStatus() {
    this.ngxLoader.start();
    this.rpoToolService
      .getCommonDrugStatus()
      .subscribe(
        (result) => {
          this.listOfDrugStatus = result.data; // Set default value to the Active option id value
          this.ngxLoader.stop();
        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop();
          console.log(error);
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }

  openAleftWizardForValidateDrug(caseNo: any) {

    const dialogRef = this.dialog.open(AlertWizardComponent, {
      backdropClass: ['smDialog'],
      disableClose: true,
      data: {
        alertIcon: "/assets/img/icons/ico.16.warning.svg",
        title: 'DCR Case Close Warning',
        bodyMessage: 'Are you sure to close this Sales force DCR Case ?',
        bodyMessage2: "Case Number : " + caseNo,
        cancelBtnText: "Cancel",
        confirmBtnText: "Ok",
        confirmButtonColor: "btn-light-blue",
        cancelButtonColor: "btn-light-red",
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log("result", result);
      if (result.data) {
        this.closeDcr(caseNo);
      }
    });
  }

  closeDcr(caseNo: any) {
    this.dcrUpdateModel = {
      status: 'close'
    };
    this.ngxLoader.start();
    this.rpoToolService
      .updateDcr(caseNo, this.dcrUpdateModel)
      .subscribe(
        (result) => {
          this.ngxLoader.stop();
          if (result.statusCode === 200) {
            this.toastService.openToast(
              result.message,
              constants.ToastPanelType.done,
              2
            );
            this.isDcrClosed = true;
          } else {
            this.toastService.openToast(
              result.message,
              constants.ToastPanelType.error,
              2
            );
          }
        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop();
          console.log(error);
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }
}
